import { Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const StatusMaster = () => {
  const [formState, setFormState] = useState({
    statusCode: "",
    statusName: "",
    active: true,
  });
  const [message, setMessage] = useState({
    isErrorMsgText: "",
    successMsgText: "",
    isErrorMsg: false,
    successMsg: false,
  });
  const [StatusData, setStatusData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [EditID, setEditID] = useState(null);
  const [isDelete, setisDelete] = useState(false);
  const [deletedID, setdeletedID] = useState(null);
  const [delIDs, setdelIDs] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [CheckBoxList, setCheckBoxList] = useState([]);
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);

  let commonDisable = CheckAccessFunc(
    "front_office",
    "Settings",
    "Service Master Configuration",
    "Status Master",
    "SubTab"
  )?.editAccess;

  useEffect(() => {
    getStatusMaster();
  }, []);

  const getStatusMaster = () => {
    try {
      setisloader(true);
      RestAPIService.getAll(Serviceurls.AYURVEDA_STATUS_MASTER)
        .then((response) => {
          if (response.data.status === "success") {
            setisloader(false);
            setStatusData(response?.data?.data || []);
          }
        })
        .catch((e) => {
          setisloader(false);
          errorMessage(e?.response?.data?.message || e.message);
        });
    } catch (e) {
      setisloader(false);
      errorMessage(e.message);
    }
  };

  const AddStatusMaster = () => {
    try {
      if (!formState?.statusName) {
        return errorMessage("Please Enter Status Name");
      }
      let data = {
        status_name: formState?.statusName,
        is_active: isActive,
      };
      setisloader(true);
      let apiCall;
      if (EditID) {
        apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_STATUS_MASTER);
      } else {
        apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_STATUS_MASTER);
      }
      apiCall
        .then((response) => {
          if (response.data.status === "success") {
            successMessage(response.data.message);
            setFormState({
              statusCode: "",
              statusName: "",
            });
            setIsActive(true);
            setEditID(null);
            getStatusMaster();
            setisloader(false);
          }
        })
        .catch((e) => {
          setisloader(false);
          errorMessage(e?.response?.data?.message || e.message);
        });
    } catch (e) {
      setisloader(false);
      errorMessage(e.message);
    }
  };

  const errorMessage = (msg) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: msg,
    });
  };

  const successMessage = (msg) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: msg,
    });
  };

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: "",
      successMsg: false,
      successMsgText: "",
    });
  };

  const tableView = () => {
    const grpDelete = () => {
      setisDelete(true);
    };
    const gridToolBar = () => {
      return (
        <Box>
          <CommonGridToolBarWithFilterText
            isDelete={delIDs?.length > 0}
            removeData={grpDelete.bind(this)}
          />
        </Box>
      );
    };

    const handleTableCheckbox = (id) => {
      let selectedIDs = new Set(id);
      setCheckBoxList(id);
      let selectedRows = StatusData.filter((row) => selectedIDs.has(row.sno));
      let FinalData = [];
      selectedRows.forEach((item) => {
        FinalData.push(item.id);
      });
      setdelIDs(FinalData);
    };

    StatusData?.forEach((element, index) => (element.sno = index + 1));

    const columns = [
      {
        field: "sno",
        headerName: "S.No",
        flex: 0.05,
        sortable: false,
        renderCell: (params) => (
          <Typography fontSize={"0.9vw"}>
            {params.row.sno}
          </Typography>
        ),
      },
      {
        field: "status_code",
        headerName: "Status Code",
        flex: 0.2,
        renderCell: (params) => (
          <Box>{params?.row?.status_code || "-"}</Box>
        ),
      },
      {
        field: "status_name",
        headerName: "Status Name",
        flex: 0.3,
        renderCell: (params) =>
          params.row.status_name ? (
            params.row.status_name?.length > 32 ? (
              <Tooltip title={params.row.status_name}>
                <Typography fontSize={"0.9vw"}>
                  {params.row.status_name?.slice(0, 30) + "..."}
                </Typography>
              </Tooltip>
            ) : (
              <Typography fontSize={"0.9vw"}>
                {params.row.status_name}
              </Typography>
            )
          ) : (
            "-"
          ),
      },
      {
        field: "is_active",
        headerName: "Status",
        flex: 0.1,
        renderCell: (params) => (
          <Box>{params?.row?.is_active ? "Active" : "Inactive"}</Box>
        ),
      },
      ...(commonDisable
        ? [
          {
            field: "action",
            headerName: "Action",
            flex: 0.1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
              <Stack direction="row" alignItems="center" spacing={1}>
                <CommonEditButton
                  size="1.5vw"
                  onClick={() => {
                    setFormState({
                      statusCode: params.row.status_code || "",
                      statusName: params.row.status_name || "",
                    });
                    setEditID(params.row.id);
                    setIsActive(params.row.is_active || false);
                  }}
                />
              </Stack>
            ),
          },
        ]
        : []),
    ];

    return (
      <Box sx={{ height: "64vh" }}>
        <DataGrid
          checkboxSelection={!!commonDisable}
          selectionModel={CheckBoxList}
          onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
          rows={StatusData}
          columns={columns}
          getRowId={(row) => row["sno"]}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {"No Records To Be Shown"}
              </Box>
            ),
          }}
          pageSizeOptions={[10, 20, 30]}
          pagination
          paginationMode="client"
          paginationModel={{
            page: page,
            pageSize: pageSize
          }}
          onPaginationModelChange={(model) => {
            setpage(model.page)
            setpageSize(model.pageSize)
          }}
          headerHeight={40}
          density="compact"
          disableRowSelectionOnClick
          loading={isloader}
          getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
          sx={{
            "& .gray-row .MuiDataGrid-cell": {
              backgroundColor: "#e8e7e7 !important",
              color: "black !important",
            },
            "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
              backgroundColor: "white !important",
              color: "black !important",
            },
            "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
              backgroundColor: "white !important",
            }
          }}
        />
      </Box>
    );
  };

  const deleteStatusMaster = () => {
    try {
      let ID = deletedID ? [deletedID] : delIDs || [];
      RestAPIService.delete(
        Serviceurls.AYURVEDA_STATUS_MASTER + `?ids=${ID}`
      )
        .then((response) => {
          if (response.data.status === "success") {
            successMessage(response.data.message);
            getStatusMaster();
            setdelIDs([]);
            setCheckBoxList([]);
            setdeletedID(null);
            setisDelete(false);
          }
        })
        .catch((e) => {
          errorMessage(e?.response?.data?.message || e.message);
        });
    } catch (e) {
      errorMessage(e.message);
    }
  };

  const PopupClose = () => {
    setisDelete(false);
    setdeletedID(null);
  };

  const textBox = (label, name, val, width, disable) => {
    return (
      <Box>
        <TextField
          size="small"
          name={name}
          value={val}
          disabled={disable}
          inputProps={{ maxlength: 30 }}
          sx={{ width: width, marginRight: "1vw" }}
          label={label}
          onChange={(e) => {
            setFormState({ ...formState, [name]: e.target.value });
          }}
          variant="outlined"
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        height: "79.5vh",
        width: "94vw",
        backgroundColor: Colors.Background,
        padding: ".5vw",
      }}
    >
      <Box
        sx={{
          height: "13vh",
          width: "93vw",
          backgroundColor: "white",
          padding: "0.5vw",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {textBox("Status Code", "statusCode", formState?.statusCode, "15vw", true)}
          {textBox("Status Name *", "statusName", formState?.statusName, "15vw", false)}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "0.5vw",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isActive}
                onChange={(e) => {
                  setIsActive(e.target.checked);
                }}
                disabled={!EditID}
                size="small"
              />
            }
            label={"Active"}
          />
          <Box sx={{ display: "flex" }}>
            <Button
              size="small"
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                width: "7vw",
                marginRight: "0.5vw",
              }}
              disabled={!commonDisable}
              onClick={() => {
                setFormState({
                  statusName: "",
                  statusCode: "",
                });
                setIsActive(true);
                setEditID(null);
              }}
            >
              Clear
            </Button>
            <Button
              size="small"
              variant="contained"
              disabled={!commonDisable}
              sx={{ textTransform: "capitalize", width: "7vw" }}
              onClick={AddStatusMaster}
            >
              {EditID ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          height: "64vh",
          width: "93vw",
          marginTop: ".5vw",
          backgroundColor: "white",
        }}
      >
        {tableView()}
      </Box>
      {message.isErrorMsg && (
        <ToastMsg
          severity={"error"}
          msg={message.isErrorMsgText}
          msgPop={msgClose}
        />
      )}
      {message.successMsg && (
        <ToastMsg
          severity={"success"}
          msg={message.successMsgText}
          msgPop={msgClose}
        />
      )}
      {isDelete && (
        <DeletePopup
          DeletTitle={`Are you sure you want to delete this item ?`}
          DeleteNotify={"This action cannot be undone."}
          deleteAlertPopupClose={PopupClose}
          removeData={deleteStatusMaster}
          ButtonText={"Yes"}
        />
      )}
      <Loader loaderOpen={isloader} />
    </Box>
  );
};

export default StatusMaster;
